import script from "./play-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./play-bar.vue?vue&type=script&lang=ts&setup=true"

import "./play-bar.vue?vue&type=style&index=0&id=3c9f7300&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9f7300"]])

export default __exports__